import { createColumnHelper } from "@tanstack/react-table"
import DataTable from "../../../components/dataTable/DataTable";
import { useState } from "react";
import ModalViewReqDados from "./ModalViewRequisicaoDados";

export default function TablePesquisaRegistros({ data }:iPropsTable) {
    const [showModalReq, setShowModalReq] = useState<boolean>(false)
    const [reqDados, setReqDados] = useState<any>({})

    function tableMiddleClickhandler(event: any) {
        // const idx = Number(event.target.parentElement.getAttribute("about"))
    }
    function tableClickhandler(event: any) {
        const idx = Number(event.target.parentElement.getAttribute("about"))
        setReqDados(data[idx])
        setShowModalReq(true)
    }
    
    return (
        <div id="graph_table" className="graph_backgrounds">
            {/* { Object.values(reqDados).length > 0 && <ModalViewReqDados show={showModalReq} handleClose={() => { setShowModalReq(false); setReqDados({}) }} dados={reqDados} /> } */}
            <ModalViewReqDados show={showModalReq} handleClose={() => { setShowModalReq(false); setReqDados({}) }} dados={reqDados} />
            <DataTable
                dados={data}
                tableSize={"fixed"}
                defaultColumns={defaultColumns}
                tableMiddleClickhandler={tableMiddleClickhandler}
                tableClickhandler={tableClickhandler}
                defaultOrder={defaultOrder}
            />
        </div>
    )
}
interface iPropsTable {
    data: any[]
}

export interface iReqMetrics {
    api: string
    data_criacao: string
    data_dia: string
    method: string
    origem: string
    payload: any
    realIp: string
    reqSize: number
    resSize: number
    responseTime: number
    statusCode: number
    timestamp: number
    url: string
    user: string
    userAgent: string
}

const columnHelper = createColumnHelper<iReqMetrics>();

const defaultColumns = [
    columnHelper.accessor("timestamp", {
        header: "timestamp",
        size: 100,
    }),
    columnHelper.accessor("data_criacao", {
        header: "Data",
        size: 250,
    }),
    columnHelper.accessor(row => `O-${row.origem}`, {
        header: "Origem",
        size: 150,
    }),
    columnHelper.accessor("method", {
        header: "Method",
        size: 50,
    }),
    columnHelper.accessor(row => `S-${row.statusCode}`, {
        header: "Status",
        size: 50,
    }),
    // columnHelper.accessor((row) => `${row.origem} - API${row.api}`, {
    //     header: "Origem",
    //     size: 200,
    // }),
    columnHelper.accessor(row => `A-${row.api}`, {
        header: "Link API",
        size: 75,
    }),
    columnHelper.accessor("url", {
        header: "URL",
        size: 350,
    }),
    columnHelper.accessor("user", {
        header: "Usuario",
        size: 100,
    }),
    columnHelper.accessor("realIp", {
        header: "realIp",
        size: 150,
    }),
    columnHelper.accessor("reqSize", {
        header: "reqSize",
        size: 100,
    }),
    columnHelper.accessor("resSize", {
        header: "resSize",
        size: 100,
    }),
    columnHelper.accessor("responseTime", {
        header: "responseTime",
        size: 100,
    }),
    columnHelper.accessor("userAgent", {
        header: "userAgent",
        size: 500,
    }),
];

const defaultOrder = [
  {
    id: "timestamp",
    desc: true,
  },
];